// Learn Loading Component
// Professional loading experience for the Learn section
// Features animated spinner, Learn logo, and contextual messaging

import './LearnLoading.css';

export function LearnLoading({
  title = "Loading Learn Content",
  subtitle = "Preparing your learning experience...",
  showLogo = true,
  className = ''
}) {
  return (
    <div className={`loading-container ${className}`}>
      <div className="loading-panel">
        {showLogo && (
          <img
            src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-learn-logo-small-transparent.png"
            alt="Revolt Learn"
            className="loading-logo"
          />
        )}

        <div className="loading-spinner"></div>

        <div className="loading-content">
          <h3 className="loading-title">{title}</h3>
          <p className="loading-subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}